import React from 'react';
export const Header = () => {
  return <div className="w-full bg-green-50 pt-8" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-80">
        <div className="text-center mb-2" data-id="element-81">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kwZXWj9hPNTYXMN2xjjLxo/0996400d-5351-4326-be57-653bd83fcb3d.png" alt="Snouty & Co. Logo" className="h-16 mx-auto" data-id="element-82" />
        </div>
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12" data-id="element-83">
          <div className="md:w-1/2" data-id="element-84">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5ZZVpXZ5xEHZokmcmcVYdP/ChatGPT_Image_20_de_jul._de_2025%2C_15_02_30.png" alt="Before and after dog dental care comparison - no toothbrush needed" className="rounded-lg shadow-md w-full" data-id="element-85" />
          </div>
          <div className="md:w-1/2 text-left" data-id="element-86">
            <h1 className="text-2xl md:text-3xl font-bold text-green-900 leading-tight mb-4" data-id="element-87">
              If Your Dog's Breath Makes You Turn Away, Try This for 30 Seconds
              Daily... and Start Enjoying Loving Kisses Again – No Toothbrush
              Needed
            </h1>
            <div className="flex gap-4 mt-6" data-id="element-88">
              <button className="bg-green-800 text-white font-semibold py-3 px-6 rounded-full hover:bg-green-700 transition" onClick={() => {
              document.querySelector('.WarningSigns')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-89">
                Learn More
              </button>
              
            </div>
          </div>
        </div>
      </div>
      <div className="w-full mt-8" style={{
      backgroundColor: '#153c22'
    }} data-id="element-90">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1MN6H8tK8AgSJQtB5PJC4v/Design_sem_nome_%2825%29.png" alt="As Seen On - Featured in major publications and media" className="w-full md:h-20 object-contain" data-id="element-91" />
      </div>
    </div>;
};